import styled from 'styled-components'

// Utils
import { breakpoint } from 'utils'

// Components
import { Title } from 'components/IndexLayout'
import { LinkButton } from 'components/Button'

export const BottomSection = styled.div`
  margin-top: 65px; /* stylelint-disable-line scales/space */

  ${breakpoint('base', 'sm')`
    margin-top: 32px;
  `}
`

export const Columns = styled.div`
  display: flex;
  align-items: flex-start;

  ${breakpoint('base', 'sm')`
    flex-direction: column;
  `}
`

export const BottomTitle = styled.p`
  margin: 0 0 8px 0;
  color: ${({ theme }) => theme.colors.foreground.secondary[1]};
  font-size: ${({ theme }) => theme.fontSizes.little};
  font-weight: ${({ theme }) => theme.fontWeights.semibold};
  text-transform: uppercase;
`

export const BottomDescription = styled.p`
  display: flex;
  margin: 0 8px 16px 0;
  color: ${({ theme }) => theme.colors.foreground.secondary[3]};
  font-size: ${({ theme }) => theme.fontSizes.smaller};

  ${breakpoint('base', 'sm')`
      margin: 0 0px 17px 0;
  `}
`

export const BreadcrumbsWrapper = styled.div`
  display: none;

  ${breakpoint('sm')`
    display: block;

    text-align: center;
    margin-top: 16px;

    + ${Title} {
      margin-top: 32px;
    }
  `}
`

export const StyledLinkButton = styled(LinkButton)`
  width: 100%;
  margin-top: 32px;
`

export const Line = styled.div`
  width: 100%;
  margin-top: 32px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border.dark.base};
`
